import {
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Page } from '../../../model/page';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ToastrService } from 'ngx-toastr';

import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/delay';

import { exportCols, newOrderTableCols } from '../master-data/master-data.cols';
import { AuthService } from '../../../auth/auth.service';
import { MasterDataService } from '../services/master-data.service';
import { SortService } from '../services/sort.service';
import { TableExtensionService } from '../table-extension.service';
import {fiveDecCompanies} from '../../../../environments/environment';
import {permissions} from '../../../permissions';

@Component({
  selector: 'app-master-data-selection-modal',
  templateUrl: './master-data-selection-modal.component.html',
  styleUrls: ['./master-data-selection-modal.component.scss'],
  providers: [
    MasterDataService,
    AuthService,
    SortService,
    TableExtensionService,
  ],
  preserveWhitespaces: true,
})
export class MasterDataSelectionModalComponent implements OnInit {
  @Output() select = new EventEmitter();

  cols: any[] = [];
  items: any[] = [];

  public loading = true;
  public page = new Page();
  public totalRecords = 0;
  public size = 50;
  public selected = [];
  public scrollHeight = '0px';
  public filtersApplied: boolean;
  public sortField: string;
  public sortOrder: number;
  protected yesNoFlags: Array<object> = [
    { value: null, text: 'All' },
    { value: '1', text: 'Yes' },
    { value: '0', text: 'No' },
  ];

  public hideTooltip = false;

  @ViewChild('header') header: ElementRef;
  @ViewChild('dataView') dataView: ElementRef;
  @ViewChild('actionbar') actionbar: ElementRef;
  @ViewChild('content') content: ElementRef;
  @ViewChild('tableHeader') tableHeader: ElementRef;
  @ViewChild('tableFilter') tableFilter: ElementRef;
  @ViewChild('paginator') paginator: ElementRef;

    public rows: any;
    protected readonly fiveDecCompanies = fiveDecCompanies;
    protected readonly parseInt = parseInt;
    protected readonly permissions = permissions;

  constructor(
    public dialogRef: MatDialogRef<MasterDataSelectionModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private masterDataService: MasterDataService,
    private authService: AuthService,
    private sortService: SortService,
    private toast: ToastrService,
    private tableExtensionService: TableExtensionService,
  ) {
    this.page.size = this.size;
    this.page.pageNumber = 0;
  }

  ngOnInit() {
    this.cols = newOrderTableCols; // exportCols;
    this.filtersApplied = false;
    this.sortField = '';
    this.sortOrder = 0;
    this.getData();
  }

  getData() {
    this.setPage({ offset: this.page.pageNumber });
  }

  onPage(event) {
    this.loading = true;
    this.page.size = event.rows;
    this.page.pageNumber = event.first / event.rows;
    this.getData();
  }

  closeDialog(resetSelected = true) {
    if (resetSelected) {
      this.selected = [];
    }
    this.dialogRef.close(this.selected);
  }

  addRecords() {
    this.closeDialog(false);
  }

  setPage(pageInfo) {
    this.loading = true;
    this.page.pageNumber = pageInfo.offset;

    this.masterDataService.getDataList(this.page).subscribe(
      (result) => {
        this.totalRecords = result.count;
        this.page.totalPages = result.count / this.page.size;
        this.rows = result.data;
        setTimeout(() => {
          this.scrollHeight = this.getScrollHeight() + 'px';
        });
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        window.dispatchEvent(new Event('resize'));
        this.toast.error('Request timed out.', 'Service Error');
      }
    );
  }

  getContentDialogHeight(): number {
    return (
      this.dataView.nativeElement.parentElement.parentElement.parentElement
        .offsetHeight -
      (this.actionbar.nativeElement.offsetHeight + 48)
    );
  }

  getScrollHeight(): number {
    return (
      this.getContentDialogHeight() -
      (this.tableHeader.nativeElement.offsetHeight +
        this.tableFilter.nativeElement.offsetHeight +
        this.paginator.nativeElement.offsetHeight +
        52)
    );
  }

  buttonPress(e, col, value) {
    if (e.keyCode === 13) {
      this.filterChanged(col, value);
    }
  }

  clearFilters() {
    const SORT_COLUMN = this.page.filterParams.hasOwnProperty('SORT_COLUMN')
      ? this.page.filterParams['SORT_COLUMN']
      : null;
    const SORT_DIRECTION = this.page.filterParams.hasOwnProperty(
      'SORT_DIRECTION'
    )
      ? this.page.filterParams['SORT_DIRECTION']
      : null;
    this.page.filterParams = {};
    if (SORT_COLUMN !== null) {
      this.page.filterParams['SORT_COLUMN'] = SORT_COLUMN;
    }
    if (SORT_DIRECTION !== null) {
      this.page.filterParams['SORT_DIRECTION'] = SORT_DIRECTION;
    }
    this.filtersApplied = false;
    this.page.pageNumber = 0;
    this.setPage({ offset: this.page.pageNumber });
  }

  filterChanged(col, value) {
    this.loading = true;

    if (col === 'MD1_SHOW_DEFAULT') {
      this.page.filterParams[col] = value;
    } else if (
      ((col === 'ORDERED_ON' ||
        col === 'COMPLETED_ON' ||
        col === 'MODIFIED_ON' ||
        col === 'CREATED_ON') &&
        value === '01-01-1970') ||
      value === ''
    ) {
      delete this.page.filterParams[col];
    } else {
      this.page.filterParams[col] = value;
    }
    const filterKeys = Object.keys(this.page.filterParams);
    this.filtersApplied =
      filterKeys.filter(
        (filterKey) =>
          filterKey !== 'SORT_COLUMN' && filterKey !== 'SORT_DIRECTION'
      ).length > 0;
    this.selected = [];

    this.page.pageNumber = 0;
    this.setPage({ offset: this.page.pageNumber });
  }

  onSort(col) {
    if (col.sort) {
      if (this.page.filterParams.hasOwnProperty('SORT_COLUMN')) {
        if (this.page.filterParams['SORT_COLUMN'] === col.field) {
          if (this.page.filterParams['SORT_DIRECTION'] === 'ASC') {
            this.page.filterParams['SORT_DIRECTION'] = 'DESC';
          } else {
            this.page.filterParams['SORT_DIRECTION'] = 'ASC';
            // does not actually update the p-table's column unless p-table is reloaded
            // delete this.page.filterParams['SORT_DIRECTION'];
            // delete this.page.filterParams['SORT_COLUMN'];
          }
        } else {
          this.page.filterParams['SORT_COLUMN'] = col.field;
          this.page.filterParams['SORT_DIRECTION'] = 'ASC';
        }
      } else {
        this.page.filterParams['SORT_COLUMN'] = col.field;
        this.page.filterParams['SORT_DIRECTION'] = 'ASC';
      }

      this.parseSort(this.page.filterParams);
      this.getData();
    }
  }

  private parseSort(filterParams) {
    const sortDetails = this.sortService.parseSort(filterParams);
    this.sortField = sortDetails.sortField;
    this.sortOrder = sortDetails.sortOrder;
  }

  onHover(e) {
    const ellipsed = e.target.offsetWidth < e.target.scrollWidth;
    this.hideTooltip = !ellipsed;
  }

  onColumnResize(event) {
    this.tableExtensionService.onColumnResize(this.cols, event);
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/oes/master-data-selection-modal/master-data-selection-modal.component.ts